var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PageComponent"},[_c('link',{attrs:{"rel":"stylesheet","href":"https://unpkg.com/leaflet@1.8.0/dist/leaflet.css","integrity":"sha512-hoalWLoI8r4UszCkZ5kL8vayOGVae1oxXe/2A4AO6J9+580uKHDO3JdHb7NzwwzK5xr/Fs0W40kiNHxM9vyTtQ==","crossorigin":""}})])
}]

export { render, staticRenderFns }